import { Injectable } from '@angular/core';
import { Country } from '@app/models/country';
import { CountryService } from '@app/services/api/country.service';
import {
  CountryActionTypes,
  LoadFail,
  LoadSuccess
} from '@core/actions/country.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class CountryEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType(CountryActionTypes.Load),
    switchMap(() =>
      this.countriesApi.get().pipe(
        map((countries: Country[]) => new LoadSuccess(countries)),
        catchError(error => of(new LoadFail(error)))
      )
    )
  );

  constructor(
    private actions$: Actions,
    private countriesApi: CountryService
  ) {}
}
